const sectionCardVitalTabCss = `
[data-type='section-card-vital-tab'] [data-attribute='card-container'] {
  color: var(--color-text, #000000);
}

[data-type='section-card-vital-tab'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-vital-tab'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-vital-tab'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-card-vital-tab'] [data-attribute='card-container'] .container-page .container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] {
  margin-bottom: 24px;
}

[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'][data-show-title='false'] {
  display: none !important;
}

[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h1,
[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h2,
[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h3 {
  font-size: 24px;
  margin: 0 0 16px 0 !important;
  line-height: normal;
}

[data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: 1.4;
}

[data-type='section-card-vital-tab'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: stretch;
  justify-content: center;
}

[data-type='section-card-vital-tab'] .wrap-card .right-card {
  width: calc((100% - 24px) / 5 * 2);
}

[data-type='section-card-vital-tab'] .wrap-card .right-card .wrap-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 30px;
}

[data-type='section-card-vital-tab'] .wrap-card .right-card .wrap-image img {
  display: block;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card {
  width: calc((100% - 24px) / 5 * 3);
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .title-card {
  font-size: 24px;
  margin-bottom: 20px;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h1,
[data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h2,
[data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h3 {
  font-size: 24px;
  margin: 0 0 16px 0 !important;
  line-height: normal;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: var(--hl-background-left-card, #eff6f9);
  padding: 10px;
  border-radius: 30px;
  margin-bottom: 16px;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item {
  text-align: center;
  font-size: 16px;
  flex: 1 1 auto;
  line-height: normal;
  margin: 0 !important;
  padding: 10px 20px;
  border-radius: 5px;
  border: solid 1px #214a88;
  color: var(--color-tab-header, #214a88);
  cursor: pointer;
  transition: all 0.3s;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item:first-child {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item:last-child {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item.active {
  background-color: var(--bg-tab-header-hover, #214a88);
  color: var(--color-tab-header-hover, #ffffff);
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item:hover {
  background-color: var(--bg-tab-header-hover, #214a88);
  color: var(--color-tab-header-hover, #ffffff);
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs {
  background-color: var(--hl-background-left-card, #eff6f9);
  padding: 32px 40px;
  border-radius: 30px;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item {
  display: none;
  min-height: 300px;
  flex-direction: column;
  justify-content: space-between;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item.active {
  display: flex;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .title-tab-content h1,
[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .title-tab-content h2,
[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .title-tab-content h3 {
  font-size: 18px;
  margin: 0 !important;
  line-height: 1.4;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .title-tab-content p {
  margin: 0 !important;
}

[data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .foot-tab-content p {
  font-size: 14px;
  line-height: 1.4;
  margin: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-card-vital-tab'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-vital-tab'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-vital-tab'] [data-attribute='card-container'] .container-page[data-show-style='true'] {
    padding: 16px;
  }

  [data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h1,
  [data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h2,
  [data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] h3 {
    font-size: 20px;
  }

  [data-type='section-card-vital-tab'] .container > .title-card[data-attribute='title-card'] p {
    font-size: 14px;
  }

  [data-type='section-card-vital-tab'] .wrap-card .right-card {
    width: 100%;
    order: 1 !important;
  }

  [data-type='section-card-vital-tab'] .wrap-card .right-card .wrap-image {
    aspect-ratio: 1/1.2;
    height: auto;
  }

  [data-type='section-card-vital-tab'] .wrap-card .left-card {
    width: 100%;
    order: 2 !important;
  }

  [data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h1,
  [data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h2,
  [data-type='section-card-vital-tab'] .wrap-card .left-card .title-card h3 {
    font-size: 20px;
  }

  [data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-header-tabs .list-tab .tab-header-item {
    font-size: 14px;
    padding: 8px 5px;
  }

  [data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs {
    padding: 16px;
  }

  [data-type='section-card-vital-tab']
    .wrap-card
    .left-card
    .wrap-content-tabs
    .list-tab-content
    .tab-content-item
    .title-tab-content
    h1,
  [data-type='section-card-vital-tab']
    .wrap-card
    .left-card
    .wrap-content-tabs
    .list-tab-content
    .tab-content-item
    .title-tab-content
    h2,
  [data-type='section-card-vital-tab']
    .wrap-card
    .left-card
    .wrap-content-tabs
    .list-tab-content
    .tab-content-item
    .title-tab-content
    h3 {
    font-size: 16px;
  }

  [data-type='section-card-vital-tab']
    .wrap-card
    .left-card
    .wrap-content-tabs
    .list-tab-content
    .tab-content-item
    .title-tab-content
    p {
    font-size: 14px;
    line-height: 1.5;
  }

  [data-type='section-card-vital-tab'] .wrap-card .left-card .wrap-content-tabs .list-tab-content .tab-content-item .foot-tab-content p {
    font-size: 12px;
    line-height: 1.5;
  }
}
`;
export default sectionCardVitalTabCss;
